import { useContext, useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom';
import { DashboardContext } from '../../../../context';
import TabContainer from '../../../../components/containers/TabContainer';
import ArtifactContainer from '../../../../components/artifacts/ArtifactContainer';
import { CustomTabProps, ResourceType } from '../../../../types';
import DocForumComments from '../../../../components/helpDocs/DocForumComments';
import Error404 from '../../../../components/error/Error404';
import AppDataWrapper from '../../../../components/containers/AppDataWrapper';

export default function SoapVisor() {
  let { apiId } = useParams()
  const dashboardContext = useContext(DashboardContext)
  const [target, setTarget] = useState<ResourceType | undefined>()
  const soapData = dashboardContext?.appData['soap']

  const tabGroup = useMemo<CustomTabProps[]>(() => {
    let tabs: CustomTabProps[] = []
    if (target) {
      target.versions[0]?.artifacts.forEach(a => {
        tabs.push({
          label: dashboardContext?.getCatalog('ART')?.find(t => t.value === a.type)?.label || a.type,
          panel: <div>
            <ArtifactContainer appModule='soap' resource={target} artifact={a} />
          </div>
        })
      })
    }
    return [
      ...tabs,
      {
        label: 'Comentarios',
        panel: <section className='section'>
          <DocForumComments resource={target} />
        </section>
      }
    ]
  }, [target])

  useEffect(() => {
    if (apiId) {
      setTarget(soapData?.find(s => s.name === apiId))
    }
  }, [apiId, soapData])

  return (
    <AppDataWrapper>
      {target ? <TabContainer tabs={tabGroup} /> : <Error404 label='No se encontro la referencia solicitada' />}
    </AppDataWrapper>
  )
}
